import { defineComponent as _defineComponent } from 'vue'
import { computed, ref, useContext } from "@nuxtjs/composition-api";
import { DataService } from "~/core/services/DataService";
import { WALLET_ERROR_CODES } from "~/core/services/utils/Constants";
import { ACTIONS as TOAST_ACTIONS } from "~/store/affility/user/feedback/modals/toast-notification/names";
import { ACTIONS as USER_FEEDBACK_ACTIONS } from "~/store/affility/user/feedback/modals/full-loader/names";
import PROVIDERS from "~/constants/providers";
import SignatureDeclinedError from "~/core/helpers/SignatureDeclinedError";
import InvalidWalletAddressError from "~/core/helpers/InvalidWalletAddressError";
import ApiService from "~/core/services/api-interaction/ApiService";


export default /*#__PURE__*/_defineComponent({
  __name: 'ConnectMyWallet',
  setup(__props) {

const context = useContext();
const connecting = ref(false);
const user = computed(() => context.store.getters['application/driver/authUser']);

const providers = computed(() => {
    let identifier = null;

    return PROVIDERS.filter((provider) => {
        if (provider.isInstalled && !provider.isInstalled()) {
            return false;
        }
        if (window.ethereum && provider.identifier) {
            identifier = window.ethereum[provider.identifier]
        }
        return (
            provider.providerName !== "injected" || identifier
        );
    });
})

const openFullScreenPopup = () => {
    context.store.dispatch(`affility/user/feedback/modals/full-loader/${USER_FEEDBACK_ACTIONS.OPEN_FULL_PAGE_LOADING}`);
}

const closeFullScreenPopup = () => {
    context.store.dispatch(`affility/user/feedback/modals/full-loader/${USER_FEEDBACK_ACTIONS.CLOSE_FULL_PAGE_LOADING}`);
}

const handleConnect = async (index) => {
    const { providerName } = providers.value[index];
    connecting.value = true;
    openFullScreenPopup();
    DataService.removeAllClaimStatusesFromLocalStorage();

    try {
        await context.store.dispatch('auth/cleanAddresses');
        localStorage.setItem("provider", providerName);
        await context.$setWeb3Provider(providerName);
        await context.store.dispatch('auth/login');

        handleConnectWalletPopupClose();

        await binaryUser();
        context.store.dispatch('user/subscription/getFrozenAutoship');

        DataService.removeFromLocalStorage('redirect');

    } catch(e) {
        if (e && e.message && e.message?.includes('User rejected the request.') || e.code === WALLET_ERROR_CODES.USER_REJECTED) {
            return;
        }

        let errorMessage = '';
        if(e instanceof SignatureDeclinedError || e instanceof InvalidWalletAddressError) {
            errorMessage = context.i18n.t(e.message);
        } else if (e.code === WALLET_ERROR_CODES.TX_ERROR) {
            errorMessage = context.i18n.t('It seems that a some request is already pending. Please check your wallet app or extension and try again.');
        } else {
            errorMessage = context.i18n.t('Something went wrong, please refresh the page and try again');
        }

        await context.store.dispatch(`affility/user/feedback/modals/toast-notification/${TOAST_ACTIONS.SHOW_ERROR_TOAST}`, {
            description: errorMessage,
        })
    } finally {
        connecting.value = false;
        closeFullScreenPopup();
    }
}

const handleConnectWalletPopupClose = () => {
    context.store.dispatch('application/popup-control/changeConnectWalletPopupStatus', false);
}

const binaryUser = async () => {
    try {
        const responseBinary = await ApiService.get(`${context.$config.binaryTreeApi}/api/users`);
        context.store.commit('application/driver/UPDATE_AUTH_USER', {
            isRoleSelected: responseBinary?.data?.user?.isRoleSelected,
            currentRankName: responseBinary?.data?.user?.currentRank,
            commissionRankName: responseBinary?.data?.user?.commissionRank,
            subscriptionExpiresAt: responseBinary?.data?.subscription_expires_at,
            isReferralLinkActive: responseBinary?.data?.user?.isReferralLinkActive,
            leftLegReffer: responseBinary?.data?.left_leg_referr,
            rightLegReffer: responseBinary?.data?.right_leg_referr,
            isFastStartIncentiveActive: responseBinary?.data?.user?.isFastStartIncentiveActive,
            binaryUserRegistrationDate: responseBinary?.data?.user?.createdAt,
            totalOwnPurchaseAmount: responseBinary?.data?.user?.totalOwnPurchaseAmount,
            totalUnilevelTeamTurnoverAmount: responseBinary?.data?.user.totalUnilevelTeamTurnoverAmount,
            sponsorWalletAddress: responseBinary?.data?.sponsorWalletAddress,
            isUsedFastStartIncentive: responseBinary?.data?.user?.isUsedFastStartIncentive,
            isBinaryTreeGuideSeen: responseBinary?.data?.user?.isBinaryTreeGuideSeen,
            isRankUpdateNotified: responseBinary?.data?.user?.isRankUpgradeNotificationSeen,
        });
    } catch (e) {
        console.log('binaryErr', e)
    }
}

return { __sfc: true,context, connecting, user, providers, openFullScreenPopup, closeFullScreenPopup, handleConnect, handleConnectWalletPopupClose, binaryUser }
}

})